import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export const WhatsAppFab = ({ raised = false }) => (
  <a
    href={SITE.whatsappHref}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    aria-label="Chat on WhatsApp"
    className={`fixed ${raised ? "bottom-[84px] lg:bottom-6" : "bottom-4"} right-4 lg:right-6 z-50 w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-gradient-to-br from-[#F0D988] to-[#C9A227] text-neutral-900 flex items-center justify-center shadow-[0_10px_30px_rgba(201,162,39,0.45)] hover:-translate-y-1 hover:shadow-[0_14px_36px_rgba(201,162,39,0.55)] transition-[transform,box-shadow] duration-300`}
  >
    <MessageCircle size={24} strokeWidth={1.5} />
  </a>
);
